import React from 'react';
import TermsFooter from "../components/TermsFooter";
import {connect} from "react-redux";

class FooterContainer extends React.Component {

	render() {
		return this.props.inApp ? null : <footer className="footer footer-terms-wrapper">
			<TermsFooter/>
		</footer>;
	}

}

export default connect(
	(state) => {
		return {
			inApp: state.browser.inApp
		}
	}
)(FooterContainer)